import{runtime as o}from"./runtime.js";function r(){return o.hostVersionsInfo?o.hostVersionsInfo.adaptiveCardSchemaVersion:void 0}export{r as getAdaptiveCardSchemaVersion};
